import { gsap } from "gsap/all"; // Also works with TweenLite and TimelineLite
import ScrollTrigger from "gsap/ScrollTrigger";
import '../i18n';
import i18next from 'i18next';
import { recommendEntry, unrecommendEntry } from '../utils/cms';
gsap.registerPlugin(ScrollTrigger);

class Recommendations {
	constructor () {
		this.recommend = this.recommend.bind(this);
		// this.unrecommend = this.unrecommend.bind(this);
		this.chechRecommendStatus = this.chechRecommendStatus.bind(this);
	}

	chechRecommendStatus (event) {
		const item = event.target.dataset.action ? event.target : event.target.closest('[data-action]');
		if (item && item.dataset.action === 'recommend') {
			this.recommend(item);
		// } else if (event.target.dataset.action === 'unrecommend') {
		// 	this.unrecommend(event.target);
		} else {
			console.log('Unrecognized action:', event.target.dataset.action);
		}
	}

	async recommend (element) {
		try {
			const recommended = await recommendEntry(element.dataset.entryId);
			element.setAttribute('data-action', 'unrecommend');
			element.innerHTML = i18next.t('Thanks!');
			const counter = document.body.querySelector('#recommendation-counter');
			const newCount = parseInt(counter.innerHTML) + 1;
			counter.innerHTML = newCount;
			const counterPostfix = document.body.querySelector('#recommendation-counter-postfix');
			counterPostfix.innerHTML = i18next.t(newCount === 1 ? 'recommendation' : 'recommendations');
		} catch (e) {
			console.log({e});
		}
	}

	// async unrecommend (element) {
	// 	try {
	// 		const unrecommended = await unrecommendEntry(element.dataset.entryId);
	// 		element.setAttribute('data-action', 'recommend');
	// 		element.innerHTML = i18next.t('Recommend');
	// 		const counter = document.body.querySelector('#recommendation-counter');
	// 		counter.innerHTML = parseInt(counter.innerHTML) - 1;
	// 		console.log(unrecommended);
	// 	} catch (e) {
	// 		console.log({e});
	// 	}
	// }
}

export default Recommendations;
